import { ActionIcon, Center } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';

import { COLORS } from '@/utils/colors';

export function AddButton({
  onClick,
  isLoading,
  size = 40,
}: {
  onClick?: any;
  isLoading?: boolean;
  size?: number;
}) {
  return (
    <Center>
      <ActionIcon
        variant="filled"
        radius="lg"
        loading={isLoading}
        m={size / 3}
        size={size * 1.5}
        onClick={onClick}
      >
        <IconPlus color={COLORS.primary} size={size} />
      </ActionIcon>
    </Center>
  );
}
